OffersTimer = window.OffersTimer ?= {}

OffersTimer.Model = require './models/offers_timer'
OffersTimer.View = require './views/offers_timer'

OffersTimer.init = ({offer}, done = ->) ->
  return done() unless offer?.offerModal?.expiresAt

  timerModel = new OffersTimer.Model
    endAt: offer?.offerModal?.expiresAt
    offerOptions: offer?.offerOptions

  timerView  = new OffersTimer.View
    model: timerModel
    i18n: I18n.scoped()

  $ ->
    timerView.render()
    done()


module.exports = OffersTimer
